import * as React from 'react';
export const discoverSvg = React.forwardRef(function discoverSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 0c4.52 0 8 3.52 8 8s-3.52 8-8 8c-4.56 0-8-3.48-8-8.12C0 3.52 3.6 0 8 0Zm.375 7c-.55 0-1 .44-1 .985 0 .58.43 1.015 1 1.015.56 0 1-.44 1-1s-.435-1-1-1Zm1.129.045L10.447 9h.244l.954-1.955h-.466l-.602 1.28-.597-1.28h-.476ZM4.448 7.01c-.394 0-.695.235-.695.545 0 .265.14.4.55.525.103.028.204.065.3.11.089.05.13.115.13.2 0 .15-.14.265-.337.265a.514.514 0 0 1-.471-.255l-.285.235c.202.25.44.36.772.36.398 0 .69-.194.758-.49l.015-.13v-.003c-.001-.308-.148-.447-.644-.597-.259-.085-.337-.14-.337-.24 0-.12.136-.21.322-.21.134 0 .263.054.353.15l.227-.25a1.078 1.078 0 0 0-.658-.215ZM6.512 7c-.664 0-1.193.445-1.193.995 0 .565.52 1 1.183 1 .181 0 .347-.03.544-.11v-.44c-.176.15-.327.21-.524.21-.44 0-.751-.275-.751-.66 0-.365.316-.655.731-.655a.79.79 0 0 1 .544.215v-.44A1.304 1.304 0 0 0 6.512 7ZM1 7.05v1.905h.638c.337 0 .58-.07.799-.22A.904.904 0 0 0 2.836 8c0-.56-.488-.95-1.193-.95H1Zm2.043 0v1.905h.436V7.05h-.436Zm8.805 0v1.905h1.233v-.32h-.798V8.12h.768v-.325h-.768V7.37h.798v-.32h-1.233Zm1.524 0v1.9h.436v-.765h.056l.602.765H15l-.7-.795c.326-.06.508-.25.509-.545 0-.36-.291-.56-.794-.56h-.643Zm-11.817.325c.285 0 .451.04.596.15A.6.6 0 0 1 2.39 8a.626.626 0 0 1-.239.485c-.14.1-.316.15-.596.15h-.12v-1.26h.12Zm12.387-.03c.27 0 .415.095.415.28 0 .195-.145.295-.425.295h-.124v-.575h.134Z',
    }),
  );
});
discoverSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var discover = {
  category: 'paymentmethod',
  colorable: true,
  name: 'discover',
  svg: discoverSvg,
};
